import { FC, useContext } from "react";
import React from "react";
import { NotificationSubscriptionContext } from "../subscriptions/notification-subscription-provider";
import { AlertBell, Colors } from "@design-system";
import { useNavigate } from "react-router";
import styles from "./header-notification-container.module.css";
import { NotificationType } from "../../graphql/types";
import { NotificationBell } from "@design-system";
import { QuestionCircleFilled } from "@ant-design/icons";
import { Avatar, Badge } from "antd";

export const HeaderNotificationContainer: FC = () => {
  const navigate = useNavigate();

  const { notificationContext, resetNotificationCount } = useContext(
    NotificationSubscriptionContext
  );

  const handleBellClick = (notificationType: NotificationType) => {
    resetNotificationCount(notificationType);
    navigate("/", { state: { notificationType } });
  };

  return (
    <div className={styles["bell-wrapper"]}>
      <span className={styles.bell}>
        <a
          onClick={() => {
            //Open new tab
            window.open("https://support.vpd.law/support/tickets/new", "_blank");
          }}
        >
          <Badge size="small" count={0} overflowCount={0}>
            <Avatar
              style={{ cursor: "pointer", backgroundColor: Colors.Primary }}
              icon={<QuestionCircleFilled />}
            />
          </Badge>
        </a>
      </span>
      <span className={styles.bell}>
        <AlertBell
          onBellClick={() =>
            notificationContext.alert.count > 0 && handleBellClick(NotificationType.Alert)
          }
          count={notificationContext.alert.count}
        ></AlertBell>
      </span>
      <span className={styles.bell}>
        <NotificationBell
          onBellClick={() =>
            notificationContext.standard.count > 0 && handleBellClick(NotificationType.Standard)
          }
          count={notificationContext.standard.count}
        ></NotificationBell>
      </span>
    </div>
  );
};
